module.exports = __webpack_public_path__ + "img/nangluctienganh.67656b38.png";